import i18n from "../../../../../i18n";
import Tables from 'src/class/Tables';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: "farm_name",
      label: i18n.t('common_words.farm'),
      minWidth: 150,
      sortable: true,
      fixed: true,
    },
    {
      prop: "lot_name",
      label: i18n.t('common_words.allotment'),
      minWidth: 150,
      sortable: true,
      fixed: true,
      align: 'center',
    },
    {
      prop: "disease_name",
      label: i18n.t('diseases.outbreak'),
      minWidth: 150,
      sortable: true,
      fixed: true,
    },
    {
      prop: "tower",
      label: i18n.t('common_words.tower_number'),
      minWidth: 100,
      sortable: true,
      align: 'left',
      align: 'center',
    },
    {
      prop: "outbreak",
      label: i18n.t('diseases.outbreaks_number'),
      minWidth: 150,
      sortable: true,
      align: 'center',
    },
    {
      prop: "cases",
      label: i18n.t('diseases.cases_quantity'),
      minWidth: 150,
      sortable: true,
      align: 'center',
    },
    {
      prop: "latitude",
      label: i18n.t('common_words.latitude'),
      minWidth: 150,
      sortable: true,
      align: 'center',
    },
    {
      prop: "longitude",
      label: i18n.t('common_words.longitude'),
      minWidth: 150,
      sortable: true,
      align: 'center',
    },
    {
      prop: "altitude",
      label: i18n.t('common_words.altitud_msmn'),
      minWidth: 150,
      sortable: true,
      align: 'center',
    }
  ];

  return { Table };
};

export default configTable;
